import React from 'react';
import styles from './style/toggle.module.css';

function Toggle({ active }: { active: boolean }) {
  return (
    <div className={`${styles.container} ${active ? styles.container_active : ''}`}>
      <div className={styles.ball} />
    </div>
  )
}

export default Toggle;
